import React from 'react';
import { UserListSkeleton } from '../Skeleton';

function UserListModal({
  isOpen,
  onClose,
  title,
  users,
  loading,
  emptyMessage,
  onUserClick,
}) {
  if (!isOpen) return null;

  return (
    <>
      <div
        className="modal-overlay"
        onClick={onClose}
        aria-hidden="true"
      />
      <div className="followers-modal" role="dialog" aria-modal="true" aria-labelledby="user-list-modal-title">
        <div className="modal-header">
          <h2 id="user-list-modal-title">{title}</h2>
          <button
            className="modal-close-btn"
            onClick={onClose}
            aria-label={`Close ${title.toLowerCase()}`}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="modal-content">
          {loading ? (
            <UserListSkeleton count={5} />
          ) : users.length === 0 ? (
            <p className="empty-state-text">{emptyMessage}</p>
          ) : (
            <div className="users-list">
              {users.map((item) => {
                const userData = item.user || item;
                const userIsPremium = userData.isPremium || userData.subscriptionTier === 'premium';
                const userId = item.followId || item.friendId || userData.id || item.id;
                return (
                  <div
                    key={userId}
                    className="user-card"
                    onClick={() => (userData.id || item.id) && onUserClick(userData)}
                  >
                    <div className={`user-avatar ${userIsPremium ? 'premium-avatar' : ''}`}>
                      {userData.photoURL ? (
                        <img src={userData.photoURL} alt="" className="user-avatar-img" />
                      ) : (
                        (userData.displayName || userData.username || 'U').charAt(0).toUpperCase()
                      )}
                    </div>
                    <div className="user-info">
                      <span className="user-name-line">
                        {userData.displayName || userData.username}
                        {userData.username && (
                          <span className="user-handle"> @{userData.username}</span>
                        )}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default UserListModal;
